import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Portal } from 'semantic-ui-react';

import ContextMenu from './ContextMenu';
import TestContextMenu from './TestContextMenu';

const menuTypes = {
  TestContextMenu,
};

export function contextMenuManagerMapState(state) {
  return {
    contextMenu: state.contextMenu,
  };
}


export class ContextMenuManager extends Component {

  render() {
    const { contextMenu } = this.props;
    const { show, location, type, menuArgs = {} } = contextMenu;

    let menu = null;

    if (show) {
      const MenuComponent = menuTypes[type];
      if (MenuComponent) {
        menu = (
          <Portal open>
            <ContextMenu location={location}>
              <MenuComponent {...menuArgs} />
            </ContextMenu>
          </Portal>
        );
      }
    }

    return menu;
  }
}

export default connect(contextMenuManagerMapState)(ContextMenuManager);
